module.exports = __webpack_public_path__ + "static/P2101466-ecfee98f7b85d7c44a74ca952bb51d81.jpg";